import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import getToken from "../../hooks/getToken";
import IvoryList from "../../assets/icons/IvoryLogo.svg";
import { useLanguage } from "../../store/language-context";
import { useTranslation } from "react-i18next";

const PasswordChange = () => {
    const { t } = useTranslation();
    const { URL } = useLanguage();
    const token = getToken();

    const [state, setState] = useState({
        oldPassword: "",
        newPassword: "",
        newPasswordConfirm: "",
    });

    const handleChange = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
    };

    async function changePassword(e) {
        e.preventDefault();

        if (state.newPassword !== state.newPasswordConfirm) {
            return Swal.fire({
                title: t('custom.err-title'),
                text: t('profile.pass-err'),
                icon: "error",
                confirmButtonText: t('custom.accept'),
            });
        }

        try {
            await axios.post(
                `${URL}/profile/change-password`,
                {
                    current_password: state.oldPassword,
                    new_password: state.newPassword,
                    new_password_confirmation: state.newPasswordConfirm,
                },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            Swal.fire({
                title: t('custom.done'),
                icon: "success",
                confirmButtonText: t('custom.accept'),
            });

            setState({
                oldPassword: "",
                newPassword: "",
                newPasswordConfirm: "",
            });

        } catch (err) {
            console.error("Error changing password:", err);
            Swal.fire({
                title: t('custom.err-title'),
                text: err.response?.data?.message || t('profile.pass-err-2'),
                icon: "error",
                confirmButtonText: t('custom.accept'),
            });
        }
    }

    return (
        <>
            <section className=" p-3 rounded-xl text-end">
                <form onSubmit={changePassword}>
                    <div className="grid grid-cols-1 gap-4">

                        <div>
                            <label htmlFor="oldPassword" className="text-secondary-tw mb-1 d-flex">
                                <img src={IvoryList} alt="list" className="me-2" /> {t('contact.now-pass')}
                            </label>
                            <input
                                type="password"
                                id="oldPassword"
                                name="oldPassword"
                                value={state.oldPassword}
                                onChange={handleChange}
                                className="select-ui"
                                required
                            />
                        </div>

                        {/* New Password */}
                        <div>
                            <label htmlFor="newPassword" className="text-secondary-tw  mb-1 d-flex">
                                <img src={IvoryList} alt="list" className="me-2" /> {t('contact.new-pass')}
                            </label>
                            <input
                                type="password"
                                id="newPassword"
                                name="newPassword"
                                value={state.newPassword}
                                onChange={handleChange}
                                className="select-ui"
                                required
                            />
                        </div>

                        {/* Confirm New Password */}
                        <div>
                            <label htmlFor="newPasswordConfirm" className="text-secondary-tw  mb-1 d-flex">
                                <img src={IvoryList} alt="list" className="me-2" /> {t('custom.ok')} {t('contact.new-pass')}
                            </label>
                            <input
                                type="password"
                                id="newPasswordConfirm"
                                name="newPasswordConfirm"
                                value={state.newPasswordConfirm}
                                onChange={handleChange}
                                className="select-ui"
                                required
                            />
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className="flex justify-end w-full mt-4">
                        <button type="submit" className="bg-primary-tw py-2 px-6 text-white rounded-lg">
                            {t('custom.update')} {t('contact.password')}
                        </button>
                    </div>
                </form>
            </section>
        </>
    );
};

export default PasswordChange;